import { BasketballIncidentId } from '@collector/sportsapi-client-legacy'

import { SameTimeIncidentsConfig } from '../../configuration'

export const sameTimeIncidentsConfig: SameTimeIncidentsConfig<BasketballIncidentId> =
  {
    excludedIncidents: [
      // status incidents
      BasketballIncidentId.NotStarted,
      BasketballIncidentId.StartDelayed,
      BasketballIncidentId.MatchAboutToStart,
      BasketballIncidentId.FirstQuarterStarted,
      BasketballIncidentId.BreakAfterFirstQuarter,
      BasketballIncidentId.SecondQuarterStarted,
      BasketballIncidentId.BreakAfterSecondQuarter,
      BasketballIncidentId.ThirdQuarterStarted,
      BasketballIncidentId.BreakAfterThirdQuarter,
      BasketballIncidentId.FourthQuarterStarted,
      BasketballIncidentId.FinishedRegularTime,
      BasketballIncidentId.WaitingForOvertime,
      BasketballIncidentId.FirstOvertimeStarted,
      BasketballIncidentId.BreakAfterFirstOvertime,
      BasketballIncidentId.SecondOvertimeStarted,
      BasketballIncidentId.BreakAfterSecondOvertime,
      BasketballIncidentId.ThirdOvertimeStarted,
      BasketballIncidentId.BreakAfterThirdOvertime,
      BasketballIncidentId.FourthOvertimeStarted,
      BasketballIncidentId.BreakAfterFourthOvertime,
      BasketballIncidentId.FifthOvertimeStarted,
      BasketballIncidentId.FirstHalfStarted,
      BasketballIncidentId.BreakAfterFirstHalf,
      BasketballIncidentId.SecondHalfStarted,
      BasketballIncidentId.FinishedAfterOvertime,
      BasketballIncidentId.FinishedAwardedWin,
      BasketballIncidentId.BreakAfter,
      BasketballIncidentId.Interrupted,
      BasketballIncidentId.Postponed,
      BasketballIncidentId.Abandoned,
      BasketballIncidentId.Cancelled,
      BasketballIncidentId.ToFinish,
      BasketballIncidentId.BreakDuringTheGame,
      // gameplay incidents
      BasketballIncidentId.JumpBall,
    ],
  }
